// deno-fmt-ignore-file
// deno-lint-ignore-file
// This code was bundled using `deno bundle` and it's not recommended to edit it manually

const objectHasOwn = Object.prototype.hasOwnProperty;
if (!objectHasOwn.call(globalThis, 'oncePerPageValues')) globalThis.oncePerPageValues = {};
function oncePerPage(id, f) {
    return function(...args) {
        if (objectHasOwn.call(globalThis.oncePerPageValues, id)) return globalThis.oncePerPageValues[id];
        const result = f(...args);
        globalThis.oncePerPageValues[id] = result;
        return result;
    };
}
const objectHasOwn1 = Object.prototype.hasOwnProperty;
async function up(rootNode) {
    const returnVals = new Map();
    const downs = [];
    for (const nodes of LayeredCallableSet(rootNode)){
        const results = await Promise.allSettled(nodes.map((node)=>()=>node.up(...node.requires.map((x)=>returnVals.get(x)))).map(applyWithoutFail));
        let failure;
        const downsInThisLayer = [];
        results.forEach((result, idx)=>{
            if (isFulfilled(result) && result.value) {
                const { value: output  } = result;
                if (objectHasOwn1.call(output, 'value')) returnVals.set(nodes[idx], output.value);
                if (output.down instanceof Function) downsInThisLayer.push(output.down);
            }
            if (isRejected(result) && !failure) failure = result.reason;
        });
        downs.unshift(applyInParallel(downsInThisLayer));
        if (failure) throw Object.assign(failure, {
            down: once(applyInSequence(downs))
        });
    }
    return {
        down: once(applyInSequence(downs)),
        value: returnVals.get(rootNode)
    };
}
function* LayeredCallableSet(rootNode) {
    const nodes = nodesIn(rootNode);
    const ran = new Map();
    const didRun = (x)=>ran.has(x);
    const canRun = (x)=>!didRun(x) && x.requires.every(didRun);
    while(ran.size < nodes.length){
        const readyToRun = nodes.filter(canRun);
        yield readyToRun;
        for (const node of readyToRun){
            ran.set(node, true);
        }
    }
}
const nodesIn = (x)=>{
    const set = new Set();
    visit(x, (y)=>set.add(y));
    return Array.from(set);
};
const isRejected = (v)=>v.status === 'rejected';
const isFulfilled = (v)=>v.status === 'fulfilled';
const applyWithoutFail = (f)=>{
    try {
        return f();
    } catch (e) {
        return Promise.reject(e);
    }
};
const visit = (node, visitor)=>{
    visitor(node);
    for (const child of node.requires){
        visit(child, visitor);
    }
};
function applyInParallel(x) {
    return async ()=>{
        const results = await Promise.allSettled(x.map(applyWithoutFail));
        const failure = results.find(isRejected);
        if (failure) throw failure.reason;
    };
}
const applyInSequence = (x)=>async ()=>{
        let error;
        for (const y of x){
            try {
                await y();
            } catch (e) {
                error = e;
            }
        }
        return error ? Promise.reject(error) : Promise.resolve();
    };
const once = (x)=>{
    let value;
    return (...args)=>{
        if (x) {
            const y = x;
            x = null;
            value = y(...args);
        }
        return value;
    };
};
export { oncePerPage as oncePerPage };
export { up as default };
